module.exports = __webpack_public_path__ + "static/media/σώμα μας.8b0fead5.mp4";